import { render, staticRenderFns } from "./eppView.vue?vue&type=template&id=2daa7a52&scoped=true"
import script from "./eppView.vue?vue&type=script&lang=js"
export * from "./eppView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa7a52",
  null
  
)

export default component.exports